import { useForm, FormProvider } from "react-hook-form";

import { Dialog } from "ui/dialog";
import CampaignTemplateSelectionStep, {
  CampaignTemplateSelectionStepActions,
} from "components/modals/create-campaign-from-template-modal/steps/campaign-template-selection-step";
import TouchpointSelectionStep, {
  TouchpointSelectionStepActions,
} from "components/modals/create-campaign-from-template-modal/steps/touchpoint-selection-step";
import CampaignDetailsStep, {
  CampaignDetailsStepActions,
} from "components/modals/create-campaign-from-template-modal/steps/campaign-details-step";

import {
  CampaignFromTemplateContextProvider,
  useCampaignFromTemplateContext,
} from "components/modals/create-campaign-from-template-modal/context/campaign-from-template-context";

import type {
  CreateCampaignFromTemplateFormData,
  CreateCampaignFromTemplateModalProps,
} from "components/modals/create-campaign-from-template-modal/create-campaign-from-template-modal.types";
import { CREATE_CAMPAIGN_FROM_TEMPLATE_SCHEMA } from "components/modals/create-campaign-from-template-modal/create-campaign-from-template-modal.constants";

// Main component that provides the context and form
export const CreateCampaignFromTemplateModal = ({
  setIsOpen = () => {},
  isOpen,
}: CreateCampaignFromTemplateModalProps) => {
  const methods = useForm<CreateCampaignFromTemplateFormData>({
    resolver: CREATE_CAMPAIGN_FROM_TEMPLATE_SCHEMA,
    mode: "onChange",
    defaultValues: {
      templates: {},
      transferStudentStatusFlag: false,
    },
  });

  return (
    <CampaignFromTemplateContextProvider isOpen={isOpen} setIsOpen={setIsOpen}>
      <FormProvider {...methods}>
        <CreateCampaignFromTemplateModalContent />
      </FormProvider>
    </CampaignFromTemplateContextProvider>
  );
};

const CreateCampaignFromTemplateModalContent = () => {
  const { step, total, setIsOpen } = useCampaignFromTemplateContext();

  const renderStep = () => {
    switch (step) {
      case 1:
        return <CampaignTemplateSelectionStep />;
      case 2:
        return <TouchpointSelectionStep />;
      case 3:
        return <CampaignDetailsStep />;
      default:
        return <CampaignTemplateSelectionStep />;
    }
  };

  const renderActions = () => {
    switch (step) {
      case 2:
        return <TouchpointSelectionStepActions />;
      case 3:
        return <CampaignDetailsStepActions />;
      default:
        return <CampaignTemplateSelectionStepActions />;
    }
  };

  return (
    <Dialog
      open
      onClose={() => setIsOpen(false)}
      size="medium"
      headline="Create campaign from Monday"
      step={{ current: step, total }}
      actions={renderActions()}>
      <form className="flex flex-1 flex-col">{renderStep()}</form>
    </Dialog>
  );
};
